// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_l2-1";
export var rowFirst = "_l2-3";
export var rowLast = "_l2-5";
export var rowMiddle = "_l2-4";
export var ticketListScroll = "_l2-2";
export var ticketStack = "_l2-0";